<div fxFlex="100" fxLayout="column" fxLayoutAlign="space-evenly stretch">
  <mat-card>
    <h2 translate>penalty.detail.title</h2>
    <p translate>penalty.detail.subtitle</p>
    <mat-card-content>
      <form [formGroup]="penaltyForm" (ngSubmit)="searchPenalty()">
        <div fxFlex fxLayout="row wrap" class="form-wrapper">
          <!--START DATEPICKERS-->
          <div fxFlex="50" fxFlex.gt-sm="30">
            <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
              <mat-label translate>investForm.initialDate</mat-label>
              <input
                #inputInitialDate
                id="initialDateInput"
                matInput
                [matDatepicker]="datepickerInitialDate"
                formControlName="initialDate"
                [max]="maxDate"
                autocomplete="off"
                [attr.data-cucumber-id]="'initialDate'"
              />
              <mat-datepicker-toggle matSuffix [for]="datepickerInitialDate"></mat-datepicker-toggle>
              <mat-datepicker
                [attr.data-cucumber-id]="'initialDatePicker'"
                id="initialDateDatepicker"
                startView="multi-year"
                #datepickerInitialDate
                (monthSelected)="chosenMonthHandler($event, datepickerInitialDate, inputInitialDate)"
                (yearSelected)="chosenYearHandler($event, inputInitialDate)"
              ></mat-datepicker>
              <mat-error *ngIf="penaltyForm.controls.initialDate.hasError('required')" translate>
                field.required
              </mat-error>
              <mat-error *ngIf="penaltyForm.controls.initialDate.errors?.dateFuture" translate>
                field.error.dateFuture
              </mat-error>
              <mat-error *ngIf="penaltyForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
            </mat-form-field>
          </div>

          <div fxFlex="50" fxFlex.gt-sm="30">
            <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
              <mat-label translate>investForm.finalDate</mat-label>
              <input
                #inputFinalDate
                id="finalDateInput"
                matInput
                [matDatepicker]="datepickerFinalDate"
                formControlName="finalDate"
                [min]="minDate"
                [max]="maxFinalDate"
                autocomplete="off"
                [attr.data-cucumber-id]="'finalDate'"
              />
              <mat-datepicker-toggle matSuffix [for]="datepickerFinalDate"></mat-datepicker-toggle>
              <mat-datepicker
                [attr.data-cucumber-id]="'finalDatePicker'"
                id="finalDateDatepicker"
                startView="multi-year"
                #datepickerFinalDate
                (monthSelected)="chosenMonthHandler($event, datepickerFinalDate, inputFinalDate)"
                (yearSelected)="chosenYearHandler($event, inputFinalDate)"
              ></mat-datepicker>
              <mat-error *ngIf="penaltyForm.controls.finalDate.hasError('required')" translate>
                field.required
              </mat-error>
              <mat-error *ngIf="penaltyForm.errors?.dateYearError" translate> field.notMoreThanAYear </mat-error>
              <mat-error *ngIf="penaltyForm.controls.finalDate.errors?.dateFuture" translate>
                field.error.dateFuture
              </mat-error>
              <mat-error *ngIf="penaltyForm.errors?.dateInvalid" translate>field.error.dateFinal</mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="40">
            <scf-custom-select-search
              [id]="'establishmentSelect'"
              formControlName="establishment"
              fxFlex="100"
              [dataInput]="establishmentsList"
              [placeholder]="'tracingReports.selectEstablishment'"
              [isRequired]="true"
              [showErrors]="penaltyForm?.controls?.establishment?.errors"
              (selectionChange)="getEstablishmentName($event)"
            >
            </scf-custom-select-search>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="100">
            <div class="penaltyForm__button-calculate">
              <button id="consultBtn" color="accent" type="submit" mat-flat-button [disabled]="penaltyForm.invalid">
                <mat-label>{{ 'investForm.consult' | translate | uppercase }}</mat-label>
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <div *ngIf="data !== null && data.results?.length > 0">
    <scf-penalty-detail-table
      [data]="data"
      [currentPage]="this.pageIndex"
      [totalPages]="this.totalPage"
      (nextPage)="obteinCurrentPage($event)"
    ></scf-penalty-detail-table>
  </div>

  <!-- Comprueba que no se muestre la primera vez -->
  <mat-card *ngIf="data !== null && data.results?.length === 0 && penaltyForm?.valid">
    <mat-card-content>
      <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
        <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="panel_footer__buttons" *ngIf="data !== null && data.results?.length > 0">
    <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
      <button
        id="createAllExcelPanel"
        mat-stroked-button
        color="accent"
        (click)="createExcel()"
        [disabled]="data !== null && data.results?.length === 0"
      >
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'request.button.excel' | translate | uppercase }}</span>
      </button>
      <button
        id="createAllPdfPanel"
        mat-stroked-button
        color="accent"
        (click)="createPdf()"
        [disabled]="data !== null && data.results?.length === 0"
      >
        <mat-icon class="icon-ic_print"></mat-icon>
        <span>{{ 'request.button.print' | translate | uppercase }}</span>
      </button>
    </div>
  </div>
</div>
